exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item[data-v-4493fca8]{border:none}.rad-left[data-v-4493fca8]{border-radius:8px!important;border-top-left-radius:0!important}.rad-right[data-v-4493fca8]{border-radius:8px!important;border-top-right-radius:0!important}.b-avatar[data-v-4493fca8]{border:1px solid #000}.small[data-v-4493fca8],small[data-v-4493fca8]{font-size:60%}", ""]);

// exports
